export const isFieldLocked = (fieldName, subTabName, tabName, lockedFields = []) => {
  return lockedFields?.some(
    field =>
        field.field_name === fieldName &&
        field.sub_tab === subTabName &&
        field.tab === tabName 
  );
};
